<div class="overlay">
  <div class="container-fluid">
    <div class="row">
      <div class="col-md-6 offset-md-3 col-lg-4 offset-lg-4 px-0">
        <div
          class="overlay__content"
          [ngClass]="{
            'overlay__content--no-image':
              takeoutCheckDone && selectedOption === 'dine-in',
            'overlay__content--with-image':
              takeoutCheckDone && selectedOption !== 'dine-in'
          }"
        >
          <div>
            <div
              *ngIf="!takeoutCheckDone"
              class="overlay__loading d-flex justify-content-center align-items-center py-5"
            >
              <i class="fa fa-spinner fa-2x text-secondary spin"></i>
            </div>
            <ng-container *ngIf="takeoutCheckDone">
            <div
              *ngIf="
                restaurantInfo !== null &&
                selectedOption !== 'dine-in'
              "
              class="overlay-header"
            >
              <p class="overlay-header__welcome">WELCOME TO</p>

              <h2 class="overlay-header__name">
                {{ restaurantInfo?.name }}
              </h2>

              <div class="overlay-header__address">
                <span class="overlay-header__address-icon">
                  <img
                    src="/assets/images/location.svg"
                    alt="address"
                    loading="lazy"
                  />
                </span>
                <span class="overlay-header__address-text">
                  <span class="d-block">{{ getAddress(restaurantInfo?.address) }}</span>
                  <span *ngIf="restaurantInfo?.phone" class="d-block">{{ restaurantInfo?.phone }}</span>
                </span>
              </div>

              <button
                *ngIf="source !== 'from-orders'"
                type="button"
                class="overlay-header__menu-button"
                (click)="activeModal.close('view-menu')"
              >
                <span class="overlay-header__menu-icon">
                  <img src="/assets/images/book.svg" alt="view menu" />
                </span>
                <span>View menu here</span>
              </button>
            </div>

            <div class="overlay-header__divider"></div>

            <!-- Show initial options after takeout check -->
            <div
              class="overlay__content-actions order-selection"
              *ngIf="!selectedOption && takeoutCheckDone"
            >
              <div class="order-selection__header">
                <p class="order-selection__eyebrow">
                  Let’s get your order started
                </p>
                <h3 class="order-selection__title">
                  How would you like to place your order?
                </h3>
              </div>

              <div class="order-selection__cards">
                <button
                  type="button"
                  class="order-card order-card--dine-in"
                  (click)="selectOption('dine-in')"
                >
                  <span class="order-card__icon">
                    <img src="/assets/images/dine-in.svg" alt="dine in" />
                  </span>
                  <span class="order-card__content">
                    <span class="order-card__title">Dine in</span>
                    <span class="order-card__subtitle">
                      Order and eat at the restaurant
                    </span>
                  </span>
                  <span class="order-card__chevron">&rsaquo;</span>
                </button>

                <button
                  *ngIf="takeoutEnabled"
                  type="button"
                  class="order-card order-card--takeout"
                  (click)="selectOption('takeout')"
                >
                  <span class="order-card__icon">
                    <img src="/assets/images/take-out.svg" alt="takeout" />
                  </span>
                  <span class="order-card__content">
                    <span class="order-card__title">Takeout</span>
                    <span class="order-card__subtitle">
                      Order ahead and pick up
                    </span>
                  </span>
                  <span class="order-card__chevron">&rsaquo;</span>
                </button>
              </div>

              <div class="report-issue-section">
                <div class="overlay-header__divider"></div>

                <button type="button" class="report-issue-banner">
                  <span>
                    <img src="/assets/images/icons.svg" alt="report an issue" />
                  </span>
                  <span class="report-issue-banner__text">
                    Report an issue
                  </span>
                </button>

                <div class="overlay-header__divider"></div>
              </div>
            </div>

            <!-- Show dine-in options after user selects dine-in -->
            <div
              class="overlay__content-actions"
              *ngIf="takeoutCheckDone && selectedOption === 'dine-in'"
            >
              <div
                class="action-box"
                (click)="activeModal.close('call-waiter')"
              >
                <img
                  src="/assets/icons/call-waiter-lg.svg"
                  alt="call a waiter"
                />
                <p class="mt-2 mb-0 primary-font-normal text-light">
                  Call a waiter
                </p>
              </div>

              <div class="action-box" (click)="activeModal.close('self-order')">
                <img src="/assets/icons/self-order-lg.svg" alt="self order" />
                <p class="mt-2 mb-0 primary-font-normal text-light">
                  Self order
                </p>
              </div>
            </div>

            <footer
              class="overlay__content-bottom-text"
              *ngIf="
                takeoutCheckDone &&
                selectedOption !== 'dine-in'
              "
            >
              <h6 class="f-14 primary-font-normal text-light mb-1">
                Powered by Smart Menu Limited.
              </h6>
            </footer>
            </ng-container>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
